import { useState } from "react"
import { useUser, UserKycStatus } from "@/api/users"
import { Button } from "@/components/ui/button"
import { WithdrawalModal } from "./withdrawal.modal"
import ArrowDownIcon from "@/components/icons/arrow-down"
import { useNavigate, useLocation } from "react-router-dom"
import { buildKycRedirect } from "@/onboarding/kyc-requirement"

export default function WithdrawalButton() {
  const { user } = useUser()
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  if (!user) return null

  if (user.hasWallet) {
    const handleClick = () => {
      if (user.kycStatus !== UserKycStatus.SUCCESS) {
        const { url, state } = buildKycRedirect({ next: location.pathname })
        navigate(url, { state })
        return
      }
      setIsOpen(true)
    }
    return (
      <>
        <WithdrawalModal open={isOpen} onOpenChange={setIsOpen} />
        <Button
          variant="default"
          className="w-full"
          onClick={handleClick}
          data-testid="withdraw"
        >
          <ArrowDownIcon direction="up" />
          Withdraw
        </Button>
      </>
    )
  } else {
    return (
      <Button variant="secondary" className="w-full" disabled>
        <ArrowDownIcon direction="up" />
        Withdraw
      </Button>
    )
  }
}
